import React from "react";
import { connect } from "react-redux";
import { Tabs } from "../../../components/Tabs";
import language from "../../../language";
import { withRouter } from "../../../utils/withRouter";
import { getStorage } from "../../../utils/storage";
import { DashboardHeader } from "../../../components/Header";
import accessMenu from "../../../utils/accessMenu";
import ReceptionSingle from "../../../components/Reception/ReceptionSingle";
import ReceptionBulk from "../../../components/Reception/ReceptionBulk";
import requestQuery from "../../../utils/queries/requestQuery";
import CheckboxQuestionnaire from "../../../components/Input/CheckboxQuestionnaire";
import Reception from "../../../components/Reception/Reception";
import ReceptionOfReturn from "../../../components/Reception/ReceptionOfReturn";

class ReceptionManagementScreen extends React.Component {
  state = {
    user: {},
    data: [],
    type: "bulk",
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });
  };

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      const { data, count } = await requestQuery(
        defaultLanguage,
        await this.returnFilters(search)
      );

      this.setState({
        data: data,
        totalPageCount: count,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleCheck(type, value) {
    this.setState({ [type]: value });
  }

  render() {
    let tabOptions = [];
    let { canReceive, canReadReception } = accessMenu();

    if (canReceive) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].new_record,
        data: (
          <div className="card">
            <div className="card-body">
              <div className="col-md-6">
                <CheckboxQuestionnaire
                  answers={[
                    {
                      key: "type",
                      value: "bulk",
                      onPress: () => this.handleCheck("type", "bulk"),
                    },
                    {
                      key: "type",
                      value: "product",
                      onPress: () => this.handleCheck("type", "product"),
                    },
                    {
                      key: "type",
                      value: "return",
                      onPress: () => this.handleCheck("type", "return"),
                    },
                  ]}
                  checked={this.state.type}
                />
                {this.state.type === "bulk" && (
                  <>
                    <ReceptionBulk />
                  </>
                )}
                {this.state.type === "product" && <ReceptionSingle />}
                {this.state.type === "return" && <ReceptionOfReturn />}
              </div>
            </div>
          </div>
        ),
      });
    }

    if (canReadReception) {
      tabOptions.push({
        title: language[this.props.defaultLanguage].historical_data,
        data: <Reception />,
      });
    }

    return (
      <>
        <div className="card-dashboard-content">
          <div className="card-body">
            <div>
              <DashboardHeader
                title={language[this.props.defaultLanguage].reception}
              />
            </div>
            <Tabs options={tabOptions} />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(ReceptionManagementScreen));
